import React, { useEffect, useState } from "react";
import api from "utils/apiService";

import MoqawelonColumn from "data/MoqawelonColumn";
import { useSearchParams } from "react-router-dom";
import CheckTable from "components/CheckTable";
import HeaderButtons from "./components/HeaderButtons";

const Index = () => {
    const [data, setData] = useState({
        data: [],
        pagination: { totalDocs: 0 },
    });
    const [loading, setLoading] = useState(true);

    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;
    const search = searchParams.get("search") || "";

    const fetchData = async () => {
        try {
            const res = await api.get(
                `/users?page=${page}${search && `&name=${search}`}`
            );

            if (res.error) {
                console.error("API Error:", res.error);
            } else {
                setData({
                    data: res?.data || [],
                    pagination: res?.pagination || { totalDocs: 0 },
                });
            }
        } catch (error) {
            console.error("Unexpected Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [page, search]);

    return (
        <section className="mt-3">
            <CheckTable
                columnsData={MoqawelonColumn(fetchData)}
                tableData={data?.data}
                title="المستخدمين"
                loading={loading}
                extraComponent={<HeaderButtons userRole={"user"} />}
                totalCount={data?.pagination?.totalDocs}
                searchExtra
            />
        </section>
    );
};

export default Index;
